<template>
  <span>
      {{displayValue}}
  </span>
</template>

<script>
import { ref } from 'vue'

export default {
    name: 'tw-ws-countTo',
    props: {
        endValue: String,
        millisec: {
            type: Number,
            default: 50
        }
    },
    setup(props){
        let displayValue = ref(0);

        if(props.endValue){
            let endValueNumber = Number(props.endValue);

            let counter = setInterval(() => {
                if(displayValue.value < endValueNumber){
                    displayValue.value ++;
                }else{
                    clearInterval(counter)
                }
            }, props.millisec)
        }

        return {
            displayValue
        }
    }
}
</script>

<style>

</style>
